<div mat-dialog-title class="dialog-title">
  <mat-label>{{ 'CHANGE_TAB' | translate }}</mat-label>
</div>
<div mat-dialog-actions>
  <button class="space-h-s btn-warn" mat-raised-button mat-dialog-close>{{ 'CLOSE' | translate }}</button>
</div>
